import { Analysis } from 'common-spectrum';
import { xrfParserPanalytical } from 'physical-chemistry-parser';

export function fromPanalytical(blob) {
  let analysis = new Analysis();
  const parsed = xrfParserPanalytical(blob);

  let meta = parsed.meta;
  analysis.pushSpectrum(
    {
      x: parsed.variables.X,
      y: parsed.variables.Y,
    },
    {
      dataType: 'X-ray fluorescence (XRF)',
      title: meta.SampleIdent,
      meta: parsed.meta,
    },
  );

  return analysis;
}
